import React, { useEffect } from 'react';
import {
  ACTION_MAIN_BOTTOM_BAR_JSX,
  ACTION_OPEN_TOOLBAR,
  ACTION_SET_APPBAR_JSX,
  ACTION_SET_TOOLBAR_JSX,
} from '../../component/MainUIFrame/constants';
import EHRToolbar from '../../component/Toolbar/toolbarContent';
import EHRBottomBar from '../Practitioner/contents/bottomBarContent';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Box, Grid, IconButton, Typography } from '@mui/material';
import { useMainFrameDispatch } from '../../component/MainUIFrame/MainFrame';
import { setEditMode } from '../../redux/features/editModeSlice';
import { setToolbarButtons } from '../../redux/features/toolbarSlice';
import { toolbarConstants } from '../../constants/toolbar/toolbarConstants';
import FHIRContact from '../../component/FhirComponents/molecule/fhirContact';
import ViewContact from './ViewContact';
import { useNavigate, useParams } from 'react-router-dom';
import { useRef } from 'react';
import { ehrAPIService } from '../../http-common';
import { useState } from 'react';
import { setProgress } from '../../redux/features/progressSlice';
import { ArrowBack } from '@mui/icons-material';
import RelationshipTree from './RelationshipTree';

const NewContact = props => {
  const reduxDispatch = useDispatch();
  const dispatch = useMainFrameDispatch();

  const [relatedPersonObject, setRelatedPersonObject] = useState();
  const [relations, setRelations] = useState([]);
  const [fetchRelationData, setFetchRelationData] = useState(0);
  const [referencePatient, setReferencePatient] = useState(false);
  const [referencePatientId, setReferencePatientId] = useState();

  // todo start
  const [patientData, setPatientData] = useState(null);
  // todo end

  const editMode = useSelector(state => {
    return state?.edit?.editMode;
  });

  const fhirPersonRef = useRef();

  const personId = useParams()?.id;

  const navigate = useNavigate();

  useEffect(() => {
    if (personId !== 'add') {
      fetchPersonData();
    }
    if (personId === 'add') {
      reduxDispatch(setEditMode(true));
    }
  }, [personId]);

  useEffect(() => {
    const isPatient =
      relatedPersonObject?.link?.filter(f =>
        f?.target?.reference?.includes('Patient')
      )?.length > 0;

    const tempReferncePatientId = relatedPersonObject?.link
      ?.filter(f => f?.target?.reference?.includes('Patient'))?.[0]
      ?.target?.reference?.split('/')?.[1];

    setReferencePatientId(tempReferncePatientId);
    setReferencePatient(isPatient);
  }, [relatedPersonObject]);

  // todo start

  useEffect(() => {
    // debugger;
    if (referencePatient) {
      const result = relatedPersonObject?.link?.find(f =>
        f?.target?.reference?.includes('Patient')
      );
      // console.log(result?.target?.reference)
      fetchPatientData(result?.target?.reference);
    }
  }, [referencePatient]);

  const fetchPatientData = async reference => {
    reduxDispatch(setProgress(true));
    debugger;
    try {
      const response = await ehrAPIService(`search/${reference}`);
      setPatientData(response?.data?.entry?.[0]?.resource);
      // console.log(response?.data?.entry?.[0]?.resource)
    } catch (e) {
    } finally {
      reduxDispatch(setProgress(false));
    }
  };

  // todo end

  useEffect(() => {
    if (relatedPersonObject?.link) {
      fetchData(relatedPersonObject?.link);
    }
  }, [relatedPersonObject, fetchRelationData]);

  const fetchData = async link => {
    reduxDispatch(setProgress(true));

    const tempRelatedPerson = [];
    const tempRelatedPersonIds = [];

    for (const item of link) {
      const id = item?.target?.reference?.split('/')?.[1];
      tempRelatedPersonIds.push(id);
    }

    const reference = `RelatedPerson/${tempRelatedPersonIds?.join(',')}`;
    try {
      const response = await getRelatedPersonData(reference);

      for (const item of response) {
        tempRelatedPerson.push({
          // ...emptyRelationData,
          relatedTo: item?.resource?.patient,
          relationType: item?.resource?.relationship?.[0]?.coding?.[0]?.code,
          id: item?.resource?.id,
          raw: item?.resource,
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
    }
    setRelations(tempRelatedPerson);
    reduxDispatch(setProgress(false));
  };

  const getRelatedPersonData = async reference => {
    const id = reference?.split('/')[1];
    try {
      const response = await ehrAPIService(`search/RelatedPerson/${id}`);
      const sortedArray = response?.data?.entry?.sort((a, b) => {
        const idA = a.resource.id;
        const idB = b.resource.id;
        if (idA < idB) {
          return -1;
        }
        if (idA > idB) {
          return 1;
        }
        return 0;
      });

      return sortedArray;
    } catch (e) {
      console.log(e);
    }
  };

  const fetchPersonData = async () => {
    reduxDispatch(setProgress(true));
    try {
      // const response = await ehrAPIService(`search/Person/${personId}`);
      const response = await ehrAPIService(
        `search/Person/${props?.personId ? props?.personId : personId}`
      );
      setRelatedPersonObject(response?.data?.entry?.[0]?.resource);
    } catch (e) {
      console.log(e);
    } finally {
      reduxDispatch(setProgress(false));
    }
  };

  const AppBarJsx = () => {
    return (
      <Grid container>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            sx={{
              color: 'appBarIcon',
            }}
            variant="h5"
          >
            <IconButton
              onClick={() => {
                if (props?.personId) {
                  props?.setListView(true);
                  props?.setCurrentSelectedRow(false);
                } else {
                  navigate('/contacts');
                }
              }}
            >
              <ArrowBack
                sx={{
                  color: 'appBarIcon',
                }}
              />
            </IconButton>
            {/* {'Contacts'} */}
            {props?.personId ? 'Account' : 'Contacts'}
          </Typography>
        </Box>
      </Grid>
    );
  };

  useEffect(() => {
    dispatch({ type: ACTION_OPEN_TOOLBAR });
    dispatch({
      type: ACTION_SET_TOOLBAR_JSX,
      payload: <EHRToolbar />,
    });
    dispatch({
      type: ACTION_SET_APPBAR_JSX,
      payload: <AppBarJsx />,
    });
    dispatch({
      type: ACTION_MAIN_BOTTOM_BAR_JSX,
      payload: <EHRBottomBar searchBar />,
    });

    return () => {
      reduxDispatch(setEditMode(false));
    };
  }, []);

  useEffect(() => {
    reduxDispatch(
      setToolbarButtons({
        actions: [
          {
            key: toolbarConstants.SAVE,
            clickAction: () => {
              if (typeof fhirPersonRef?.current?.save === 'function') {
                fhirPersonRef?.current?.save();
              }
            },
            disabled: !editMode,
          },
          {
            key: toolbarConstants.CANCEL,
            clickAction: () => {
              if (props?.personId) {
                props?.setListView(true);
                props?.setCurrentSelectedRow(false);
              } else {
                navigate('/contacts');
              }
            },
            // disabled: !editMode,
          },
        ],
        module: 'Contact',
        // editSwitch: personId !== 'add',
        editSwitch:
          (props?.personId ? false : personId !== 'add') && !referencePatient,
      })
    );
    return () => {
      reduxDispatch(setToolbarButtons({ actions: [] }));
    };
  }, [editMode, personId, referencePatient, relations]);

  return (
    <>
      <Grid container>
        <Grid
          item
          sm={12}
          pl={2}
          pt={2}
          // className="overflow"
          className={!props?.personId && 'overflow-grid'}
        >
          <Box p={2}>
            {referencePatient && (
              <Alert icon={false} severity="warning">
                <Typography display={'inline'}>
                  This Person can be edited from Patient Demographics
                </Typography>
                {/* <Typography display={'inline'} color={'blue'} sx={{textDecoration:'underline', cursor:'pointer'}} onClick={()=>{
                                    navigate(`/ehr/record/${referencePatientId}`)
                                }}>
                                    ({referencePatientId})
                                </Typography> */}
              </Alert>
            )}
            {!referencePatient && props?.personId && (
              <Alert icon={false} severity="warning">
                <Typography display={'inline'}>
                  This Person can be edited from Contact Demographics
                </Typography>
              </Alert>
            )}
          </Box>
          {/* {personId !== 'add' && !referencePatient && (
                        <RelationshipTree
                            relatedpersonObject={relatedPersonObject}
                            relations={relations}
                        />
                    )} */}
          {editMode ? (
            <FHIRContact
              ref={fhirPersonRef}
              isCreate={personId === 'add'}
              relatedpersonObject={relatedPersonObject}
              relations={relations}
              setFetchRelationData={setFetchRelationData}
              fetchRelationData={fetchRelationData}
              // setListView={setListView}
            />
          ) : (
            personId !== 'add' && (
              <ViewContact
                relatedpersonObject={relatedPersonObject}
                relations={relations}
                patientData={patientData}
              />
            )
          )}
          {personId !== 'add' && !referencePatient && (
            <RelationshipTree
              relatedpersonObject={relatedPersonObject}
              relations={relations}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default NewContact;
